module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_desc b.5cba7f18.svg";